// This icon file is generated automatically.
var PExclamationCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8z" } }, { "tag": "path", "attrs": { "d": "M6.25 9.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM6.63 8h.75c.06 0 .12-.06.12-.13V3.63a.13.13 0 00-.13-.12h-.75a.13.13 0 00-.12.13v4.25c0 .06.06.12.13.12z" } }] }] }, "name": "p-exclamation-circle", "theme": "outlined" };
export default PExclamationCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PExclamationCircleOutlined.js
// module id = 3367
// module chunks = 0